import { render, staticRenderFns } from "./_TemplateSchemaSettingsCollectionWrapper.vue?vue&type=template&id=4a3b9971&scoped=true&"
import script from "./_TemplateSchemaSettingsCollectionWrapper.vue?vue&type=script&lang=js&"
export * from "./_TemplateSchemaSettingsCollectionWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3b9971",
  null
  
)

export default component.exports